import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 gap-4" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "text-red-400 text-sm mt-2"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, "Отказано службой безопасности", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Обратитесь в службу безопасности", -1)
const _hoisted_8 = {
  key: 1,
  class: "text-red-400 text-sm mt-2"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "Авто не прошло проверку службы безопасности", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "Обратитесь в службу безопасности", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 0,
  class: "grid grid-cols-1 gap-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_input = _resolveComponent("new-input")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_new_select = _resolveComponent("new-select")!
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_new_modal = _resolveComponent("new-modal")!

  return (_openBlock(), _createBlock(_component_new_modal, {
    title: "Добавление автомобиля",
    loading: _ctx.loading,
    overflow: true,
    "confirm-disabled": !_ctx.sb_state_car.is_success,
    onSubmit: _ctx.emitCreate,
    onCancel: _ctx.emitCancel
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_new_input, {
              placeholder: "Гос. номер",
              class: "w-full",
              value: _ctx.state.number,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.number) = $event)),
              "is-invalid": _ctx.state_form$.number.$error || _ctx.car_form$.number.$error,
              "validation-errors": _ctx.state_form$.number.$errors || _ctx.car_form$.number.$errors
            }, null, 8, ["value", "is-invalid", "validation-errors"]),
            _createVNode(_component_new_button, {
              class: "flex items-center text primary small ml-2 py-3",
              loading: _ctx.sb_state_car.is_loading,
              onClick: _ctx.checkSbStatusCar
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createTextVNode(" Проверить ")
              ]),
              _: 1
            }, 8, ["loading", "onClick"])
          ]),
          (_ctx.isRejectedCar)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("p", null, [
                  _hoisted_6,
                  _createTextVNode(" (" + _toDisplayString(_ctx.sb_state_car.reject_comment) + ") ", 1)
                ]),
                _hoisted_7
              ]))
            : _createCommentVNode("", true),
          (_ctx.isNotCheckedCar)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
            : _createCommentVNode("", true)
        ]),
        (_ctx.sb_state_car.is_success)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_new_input, {
                placeholder: "Модель",
                value: _ctx.state.model,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.model) = $event)),
                "is-invalid": _ctx.state_form$.model.$error,
                "validation-errors": _ctx.state_form$.model.$errors,
                disabled: _ctx.is_loading
              }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
              _createVNode(_component_new_select, {
                placeholder: "Компания",
                value: _ctx.state.company_id,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.company_id) = $event)),
                "is-invalid": _ctx.state_form$.company_id.$error,
                "validation-errors": _ctx.state_form$.company_id.$errors,
                disabled: _ctx.is_loading,
                loading: _ctx.data_state.carriers.is_loading,
                failed: _ctx.data_state.carriers.is_failed,
                "error-text": "При получении списка компаний произошла ошибка",
                options: _ctx.data_state.carriers.list,
                "infinite-scroll": "",
                onRefresh: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadCarriers(_ctx.data_state.carriers.pagination.current_page))),
                onLoadmore: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadMoreCarriers(_ctx.data_state.carriers.pagination.current_page + 1))),
                onSearch: _ctx.searchCarriers,
                onOptionBySearch: _ctx.unshiftFindedCarrier
              }, null, 8, ["value", "is-invalid", "validation-errors", "disabled", "loading", "failed", "options", "onSearch", "onOptionBySearch"]),
              _createVNode(_component_new_select, {
                placeholder: "Тип машины",
                searchable: false,
                value: _ctx.state.vehicle_type_id,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.vehicle_type_id) = $event)),
                "is-invalid": _ctx.state_form$.vehicle_type_id.$error,
                "validation-errors": _ctx.state_form$.vehicle_type_id.$errors,
                disabled: _ctx.is_loading,
                loading: _ctx.data_state.vehicle_types.is_loading,
                failed: _ctx.data_state.vehicle_types.is_failed,
                "error-text": "При получении списка типов машин произошла ошибка",
                options: _ctx.data_state.vehicle_types.list,
                "infinite-scroll": "",
                onRefresh: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadVehicleTypes(_ctx.data_state.vehicle_types.pagination.current_page))),
                onLoadmore: _cache[7] || (_cache[7] = ($event: any) => (
                        _ctx.loadMoreVehicleTypes(_ctx.data_state.vehicle_types.pagination.current_page + 1)
                    ))
              }, null, 8, ["value", "is-invalid", "validation-errors", "disabled", "loading", "failed", "options"]),
              _createVNode(_component_new_input, {
                placeholder: "Кубатура",
                value: _ctx.state.cubature,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.cubature) = $event)),
                "is-invalid": _ctx.state_form$.cubature.$error,
                "validation-errors": _ctx.state_form$.cubature.$errors,
                disabled: _ctx.is_loading
              }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
              _createVNode(_component_new_select, {
                placeholder: "Грузоподъемность",
                value: _ctx.state.ftl_car_type_id,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.ftl_car_type_id) = $event)),
                "is-invalid": _ctx.state_form$.ftl_car_type_id.$error,
                "validation-errors": _ctx.state_form$.ftl_car_type_id.$errors,
                disabled: _ctx.is_loading,
                loading: _ctx.data_state.ftl_car_types.is_loading,
                failed: _ctx.data_state.ftl_car_types.is_failed,
                "error-text": "При получении списка грузоподъемностей произошла ошибка",
                options: _ctx.data_state.ftl_car_types.list,
                label: "title",
                "search-by": "title",
                onRefresh: _cache[10] || (_cache[10] = ($event: any) => (_ctx.loadFtlCarTypes(_ctx.data_state.ftl_car_types.pagination.current_page)))
              }, null, 8, ["value", "is-invalid", "validation-errors", "disabled", "loading", "failed", "options"]),
              _createVNode(_component_new_input, {
                placeholder: "Номер тех. паспорта",
                value: _ctx.state.tech_passport_number,
                "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.tech_passport_number) = $event)),
                disabled: _ctx.is_loading
              }, null, 8, ["value", "disabled"]),
              _createVNode(_component_file_reader, {
                accept: "image/*",
                placeholder: "Тех. паспорт",
                multiple: "",
                disabled: _ctx.is_loading,
                value: _ctx.state.technicalPassport,
                "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.technicalPassport) = $event))
              }, null, 8, ["disabled", "value"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["loading", "confirm-disabled", "onSubmit", "onCancel"]))
}